import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {SchemeLink} from '../../applink/SchemeLink';
import {PromotionBannerItem as PromotionBanner} from '../../design-system/organisms/PromotionBannerItem/PromotionBannerItem';
import {PromotionBannerItem} from '../../graphql/generated/types';
import {aggregateAndSendLog} from '../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT} from '../../logging/logEvent';
import {putTiaraObjectProps} from '../../logging/putTiaraObjectProps';
import {twMerge} from '../twMerge';

export function PromotionBannerContainer({
  promotionBanner: {scheme, eventLog, title, leftImage, rightImage},
  className,
}: {
  promotionBanner: PromotionBannerItem;
  className?: string;
}) {
  const {ref, inView, entry} = useInView();

  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '프로모션배너_노출',
        customProps: {
          user_action: 'imp',
        },
        viewimp_contents: {
          imp_provider: 'service',
          imp_type: 'vimp',
        },
      });
    }
  }, [entry, inView]);

  return (
    <div
      className="mb-8pxr"
      {...putTiaraObjectProps({
        click: {
          layer1: '프로모션',
          imp_id: 'spromo_b_001',
          imp_provider: 'service',
        },
        viewimp_contents: {
          imp_id: 'spromo_b_001',
          layer1: '프로모션',
        },
        customProps: {
          section_type: '프로모션',
        },
      })}
    >
      <SchemeLink scheme={scheme || undefined}>
        <PromotionBanner
          ref={ref}
          {...putTiaraObjectProps(eventLog)}
          bannerTitle={title}
          leftImageUrl={leftImage}
          rightImageUrl={rightImage || undefined}
          onClick={e => LOG_CLICK_EVENT('프로모션배너_클릭', e)}
          className={twMerge('mx-11pxr w-auto', className)}
        />
      </SchemeLink>
    </div>
  );
}
